import React,{useRef} from "react";
import dynamic from "next/dynamic";
import styles from "../../styles/pages/emptwin.module.scss";
const Icons = dynamic(() => import("../../public/assets/svg/index"));
const Card = dynamic(() => import("../dynamicBotCard"));
import Carousels from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import endpoints from "../../utility/endpoints";
const BasicForm = dynamic(() => import("../basicForm"));
const Video = dynamic(() => import("../../pages/videoModal"));
const Empbanner = dynamic(() => import("../purchaseETBanner"));
const Emptwinskills = dynamic(() => import("../emptwinpurchaseskills"));
import _get from "lodash/get";
import { useRouter } from "next/router";
import ReactPlayer from "react-player";
import axios from "axios";
import { useState, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
const SuccessModal = dynamic(() => import("../../pages/successModal"));
import { useMediaQuery } from "react-responsive";
const Loader = dynamic(() => import("../Loader"));
import { sessionTimeOutCheck, checkExpiry } from "../../redux/global/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CartModal from "../Pages/Cartmodal";

function index(props) {
  const router = useRouter();
  //console.log("props  ------ Employeetwin page  -----", props);

  let initialStates = {};
  let [state, setState] = React.useState(initialStates);
  
  const [successModal, setSuccessModal] = React.useState(false);
  const [cartModal, setCartModal] = React.useState(false);
  const [empdata, setEmpdata] = useState([]);
  const [softskilldata, setSoftskilldata] = useState([]);
  
  const [categorydata, setCategorydata] = useState(false);
  const [subcategorydata, setSubcategorydata] = useState(false);
  const backgroundUrlMobile = _get(
    props.data[0],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrl = _get(
    props,
    "data[0]component.content.field_background_image[0].file_url",
    ""
  );
  const emptwinDetails = _get(
    props,
    "data[0].component.content.field_details",
    ""
  );
  const emptwinHeading = _get(
    props,
    "data[0]component.content.field_hedaing",
    ""
  );
  const backgroundUrlMobile1 = _get(
    props.data[10],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrl1 = _get(
    props,
    "data[10]component.content.field_background_image[0].file_url",
    ""
  );
  const backgroundUrl11 = _get(
    props,
    "data[0].component.content.field_background_image[1].file_url",
    ""
  );
 //console.log('backgroundUrl11',backgroundUrl11);
// console.log('getting all images',props.data[0].component.content.field_background_image[1].file_url);
  const emptwinDetails1 = _get(
    props,
    "data[10].component.content.field_details",
    ""
  );
  const emptwinHeading1 = _get(
    props,
    "data[10]component.content.field_hedaing",
    ""
  );
  const backgroundUrlMobileemptwin = _get(
    props.data[11],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrlemptwin = _get(
    props,
    "data[11]component.content.field_background_image[0].file_url",
    ""
  );
  const { data } = props;
  const onValueChange = async (e) => {
    const value = e.target.value;
    //console.log(e.target.id,e.target.value);
    if(e.target.id ==="leadPlatform" && e.target.value ==="Supply Chain")
    {
      setCategorydata(true);

    }
    else
      {
        setCategorydata(false);
  
      }
    
  }
  const [subcategoryindex,setSubcategoryindex]=useState([]);
  const onValueChangecategory = async (e) => {
    const value = e.target.value;
    //console.log(e.target.id,e.target.value);
    if((e.target.id ==="category" &&  e.target.value ==="Plan"))
    {
      setSubcategorydata(true);
      setSubcategoryindex(_get(
        props.data[4].component.content
          .field_bot_store_filters_fields[2].field_dropdown_option_component[0],
        "field_options",
        []
      ))
      

    }
    else if((e.target.id ==="category" &&  e.target.value ==="Master Data"))
    {
      setSubcategorydata(true);
      setSubcategoryindex(_get(
        props.data[4].component.content
          .field_bot_store_filters_fields[2].field_dropdown_option_component[1],
        "field_options",
        []
      ))
    }
    else
    {
      setSubcategorydata(false);
    }
  }
  //console.log(subcategoryindex);
  const content = _.get(data[4], "component.content", "");
  const clearALLFilter = () => {
    window.scrollTo(0,200)
    setState({})
    //setLoadState(true)
    setNoResultFlag(false)
   
    
   // dispatch(getBotsAction(0))
   // setAllBots([])
   // setInfiniteKey(infiniteKey + 1)
   // setHasMoreBots(true)
    
    
  };
  const inputChange = (e) => {
    if (e.target.value.length == 0) {
      //  console.log(e.target.value, "before");
      let statess = state;
      delete statess.searchinput;
      setSearchinput("")
      setState({...statess})
      if (_.isEmpty(statess)) {
        clearALLFilter();
       
      }
    } else {
   
    setSearchinput( e.target.value)
    debouncedCallApi()
    
    }
  
  };
  const inputRef = useRef(null)

  const goTo = (link) => {
    // console.log(link);
    router.push(link);
  };
  


  const moveToCez = (sectionName) => {
    router.push({
      pathname: props.pageRoutes.CognitiveExperienceZone,
      query: { cezSection: sectionName },
    });
  };
  
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const empid = params.get('empTwinId');
 //console.log(empid);
 localStorage.setItem('empid', JSON.stringify(empid));

  const reactRef = React.useRef(null);
  const localHandler = async (e) => {
    let auth = JSON.parse(localStorage.getItem("auth")).data;
    const { data } = await axios({
      url: `${endpoints.baseUrl}/twin/search?empTwinId=${empid}`,
      method: "GET",
      headers: {
        Authorization: `${auth.accessToken}|${auth.email}`,
      },

    });
    //console.log(data);
    if (data.code === 200) {
      setEmpdata(data.allSkill[0]);
      setSoftskilldata(data.softSkill);
    }
    else
    {
      console.log("No data found")
    }
  
}

React.useEffect(() => {
  localHandler();
},[])
//console.log(empdata);
let auth =  JSON.parse(localStorage.getItem("auth")).data;
//console.log(auth.email);

  return (
    <div className={`${styles.landingContainer}`}>
      {successModal ? (
        <SuccessModal
          setSuccessModal={setSuccessModal}
          title={"Request a demo"}
          message={message}
        />
      ) : null}
      <div id="headTop"></div>
      <Empbanner
        data={{
          emptwinDetails,
          emptwinHeading,
          backgroundUrl,
          backgroundUrl11,
          backgroundUrlMobile,
        }}
        name="purchaseET"
        empdata={empdata}
      />

      <Emptwinskills
        data={{
          emptwinDetails1,
          emptwinHeading1,
          backgroundUrl1,
          backgroundUrlMobile1,
        }}
        name="employeetwindetails"
        allskillsData={props.data}
        data1={props.softskill1}
        empid={empid}
        softskilldata={softskilldata}
        content={content}
        softSkill={props.softskill}
        pageRoutes={props.pageRoutes}
        globalData={props.globalData}
      />
    
    </div>
  );
}

const mapStateToProps = (state) => {
  //console.log("state", state);
  return {
    session: state.session.session,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    sessionTimeOutCheck: bindActionCreators(sessionTimeOutCheck, dispatch),
    checkExpiry: bindActionCreators(checkExpiry, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(index);

